import { render, staticRenderFns } from "./ticketReply.vue?vue&type=template&id=76988f3c&"
import script from "./ticketReply.vue?vue&type=script&lang=js&"
export * from "./ticketReply.vue?vue&type=script&lang=js&"
import style0 from "./ticketReply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports